import React from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram, faLinkedin, faYoutube, faTwitter } from '@fortawesome/free-brands-svg-icons';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  // Reusable style objects
  const columnStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    flex: 1
  };

  const headingStyle = {
    fontSize: '14px',
    fontWeight: '700',
    color: '#1a1a1a',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    marginBottom: '8px'
  };

  const linkStyle = {
    fontSize: '14px',
    color: '#666',
    textDecoration: 'none',
    transition: '0.3s'
  };

  const socialIconStyle = {
    fontSize: '20px',
    color: '#4A5568',
    marginRight: '20px',
    textDecoration: 'none'
  };

  return (
    <footer style={{ backgroundColor: '#ffffff', paddingTop: '60px', borderTop: '1px solid #eaeaea', fontFamily: "'Inter', sans-serif" }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
        
        {/* Main Grid */}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '40px', marginBottom: '40px' }}>
          
          {/* Info Column */}
          <div style={{ flex: '1.5', minWidth: '250px' }}>
            <h3 style={headingStyle}>EarthID Internaltional Bank</h3>
            <p style={{ fontSize: '14px', color: '#718096', lineHeight: '1.6', maxWidth: '300px' }}>
              Connect with us for suggestions and support.
            </p>
            <div style={{ marginTop: '20px', display: 'flex' }}>
              <a href="https://twitter.com/earthid_ssi" target="_blank" style={socialIconStyle}><FontAwesomeIcon icon={faTwitter} /></a>
              <a href="https://linkedin.com/company/myearthid/" target="_blank" style={socialIconStyle}><FontAwesomeIcon icon={faLinkedin} /></a>
              <a href="https://facebook.com/myearth.id/" target="_blank" style={socialIconStyle}><FontAwesomeIcon icon={faFacebook} /></a>
              <a href="https://instagram.com/myearthid/" target="_blank" style={socialIconStyle}><FontAwesomeIcon icon={faInstagram} /></a>
              {/* <a href="https://youtube.com" target="_blank" style={socialIconStyle}><FontAwesomeIcon icon={faYoutube} /></a> */}
            </div>
          </div>

          {/* Links Column 1 */}
          <div style={columnStyle}>
            <h3 style={headingStyle}>Company</h3>
            <NavLink to="/" style={linkStyle}>Department</NavLink>
            <NavLink to="/" style={linkStyle}>Residences</NavLink>
            <NavLink to="/" style={linkStyle}>Business</NavLink>
          </div>

          {/* Links Column 2 */}
          <div style={columnStyle}>
            <h3 style={headingStyle}>Resources</h3>
            <NavLink to="/" style={linkStyle}>Payment</NavLink>
            <NavLink to="/" style={linkStyle}>Terms</NavLink>
            <NavLink to="/" style={linkStyle}>News</NavLink>
          </div>

          {/* Links Column 3 */}
          <div style={columnStyle}>
            <h3 style={headingStyle}>Contact</h3>
            <NavLink to="/" style={linkStyle}>Administration</NavLink>
            <NavLink to="/" style={linkStyle}>Planning</NavLink>
            <NavLink to="/" style={linkStyle}>Support</NavLink>
          </div>
        </div>

        <hr style={{ border: '0', borderTop: '1px solid #f0f0f0', margin: '0' }} />
      </div>

      {/* Bottom Bar */}
      <div style={{ backgroundColor: '#42145f', padding: '20px 0', marginTop: '40px' }}>
        <p style={{ 
          textAlign: 'center', 
          color: '#ffffff', 
          fontSize: '13px', 
          margin: 0, 
          opacity: '0.8',
          letterSpacing: '0.5px' 
        }}>
          © {currentYear} EarthID, Inc. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;